/**
 * URL utility functions for digital marketing features
 */

/**
 * Ensures URL has proper protocol (https://)
 * @param url - The URL to process
 * @returns URL with protocol or empty string if no URL provided
 */
export const ensureHttpsProtocol = (url?: string): string => {
    if (!url) {
        return "";
    }

    try {
        // Check if URL already has a valid protocol
        new URL(url);
        return url;
    } catch {
        // URL is invalid, likely missing protocol
        return `https://${url}`;
    }
};

/**
 * Removes protocol (http:// or https://) and www. prefix from URL
 * @param url - The URL to clean
 * @returns URL without protocol and www prefix
 * @example
 * removeProtocolAndWww("https://www.example.com") // returns "example.com"
 * removeProtocolAndWww("http://example.com") // returns "example.com"
 * removeProtocolAndWww("www.example.com") // returns "example.com"
 */
export const removeProtocolAndWww = (url: string): string => {
    return url.replace(/^(https?:\/\/)?(www\.)?/, "");
};

export const extractDomain = (url: string): string => {
    try {
        return new URL(url).hostname.replace(/^www\./, "");
    } catch {
        return removeProtocolAndWww(url).split("/")[0];
    }
};
